import { Link } from "react-router-dom";
import Container from "../layout/Container";
import List from "../layout/List";
import Listitem from "../layout/Listitem";
import AuctionCustomShipping from "./AuctionCustomShipping";

const AuctionCustomDetails = () => {
  return (
    <div>
      <Container>
        <div className="h-[370px] w-[551px] rounded-md border border-solid border-darkGreen border-opacity-30 px-5 pt-6">
          <div className="flex">
            <div className="flex w-[35%] flex-col gap-y-2.5">
              <List className="flex items-center">
                <Listitem
                  className="font-regular font-pop text-sm text-darkGreen"
                  title="Listed"
                />
              </List>
              <List className="flex items-center">
                <Listitem
                  className="font-regular font-pop text-sm text-darkGreen"
                  title="Estimated Value"
                />
              </List>
              <List className="flex items-center">
                <Listitem
                  className="font-regular font-pop text-sm text-darkGreen"
                  title="Remaining Time"
                />
              </List>
              <List className="flex items-center">
                <Listitem
                  className="font-regular font-pop text-sm text-darkGreen"
                  title="Current Price R"
                />
              </List>
            </div>
            <div className="flex w-[35%] flex-col gap-y-2.5">
              <List className="flex items-center">
                <Listitem
                  className="font-regular font-pop text-sm text-darkGreen"
                  title="Apr 15, 2016"
                />
              </List>
              <List className="flex items-center">
                <Listitem
                  className="font-regular font-pop text-sm text-darkGreen"
                  title="R 1245,000.00"
                />
              </List>
              <List className="flex items-center">
                <Listitem
                  className="font-pop text-xs font-medium text-primary"
                  title="1 Day 18:44:05"
                />
              </List>
              <List className="flex items-center gap-x-3">
                <Listitem
                  className="font-regular font-pop text-sm text-primary"
                  title="R 2,681.00"
                />
                <span className="font-pop text-xs font-medium text-[#1D9BF0]">
                  Reserve Met
                </span>
              </List>
            </div>
            <div className="w-[30%]">
              <div className="flex justify-end">
                <div className="mb-3 flex flex-col justify-center">
                  <p className="px-8 font-pop text-xs font-semibold text-darkGreen">
                    <span>3</span> Watching
                  </p>
                  <div className="flex justify-center">
                    <Link
                      to="#"
                      className="mt-1 w-[110px] border-b border-solid border-[#1D9BF0] font-pop text-xs font-semibold text-[#1D9BF0]"
                    >
                      + Add to watchlist
                    </Link>
                  </div>
                </div>
              </div>
              <div className="flex justify-end">
                <div className="flex flex-col">
                  <div className="mb-3 w-[91px]">
                    <p className=" flex justify-center rounded-md bg-quantityColor py-1 px-3 font-pop text-sm font-semibold text-primary">
                      5 bid(s)
                    </p>
                  </div>
                  <div className="flex justify-end">
                    <p className=" flex justify-end border-b border-solid border-primary font-pop text-xs font-semibold">
                      Bid history
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-5">
            <h5 className="font-regualr pb-1 font-pop text-xs text-[#194448]">
              R200 min bid increment
            </h5>
            <div>
              <div className="flex items-center gap-x-5">
                <div className="flex items-center border-b border-solid border-primary">
                  <p className="bg-primary py-[9px] px-5 font-pop text-sm font-semibold text-white">
                    R
                  </p>
                  <input
                    className="font-regular w-[140px] bg-bgInput py-[7px] px-2.5 font-pop text-base text-darkGreen outline-none"
                    type="text"
                    placeholder="2,881"
                  />
                </div>
                <div className="flex w-full justify-between">
                  <button className="rounded-md bg-primary py-2.5 px-3.5 font-pop text-xs font-bold text-white">
                    Quick Bid R2,881.00
                  </button>
                  <button className="rounded-md bg-primary py-2.5 px-10 font-pop text-xs font-bold text-white">
                    Submit Bid
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-2">
            <h5 className="font-regualr pb-1 font-pop text-xs text-[#194448]">
              R200 min bid increment
            </h5>
            <div>
              <div className="flex items-center gap-x-5">
                <div className="flex items-center border-b border-solid border-primary">
                  <p className="bg-primary py-[9px] px-5 font-pop text-sm font-semibold text-white">
                    R
                  </p>
                  <input
                    className="font-regular w-[140px] bg-bgInput py-[7px] px-2.5 font-pop text-base text-darkGreen outline-none"
                    type="text"
                    placeholder="4,000.00"
                  />
                </div>
                <div className="flex w-full justify-between">
                  <button className="rounded-md bg-primary py-2.5 px-12 font-pop text-xs font-bold text-white">
                    Buy now
                  </button>
                  <button className="rounded-md bg-primary py-2.5 px-8 font-pop text-xs font-bold text-white">
                    Make an offer
                  </button>
                </div>
              </div>
            </div>
          </div>
          <AuctionCustomShipping />
        </div>
      </Container>
    </div>
  );
};

export default AuctionCustomDetails;
